import request from '@/utils/request'

export default {
  /**
   * @param id
   * @returns {*}
   */
  getMerchantDetail() {
    return request.get('/merchants/detail')
  },

  /**
   * @param id
   * @returns {*}
   */
  getById(id) {
    return request.get(`/merchants/${id}`)
  },

  /**
   * 更新商户信息
   * @param id
   * @param data
   * @returns {Entry|AxiosPromise<any>|IDBRequest|Promise<void>}
   */
  updateById(id, data) {
    return request.put(`/merchants/${id}`, data)
  },

  /**
   * 修改商家的字段
   * @param data
   * @returns {Entry|AxiosPromise<any>|Promise<*>|IDBRequest|Promise<void>}
   */
  toggleField(data) {
    return request.put(`/merchants/update/toggle-field`, data)
  }
}
